import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import { asyncRoutes, constantRoutes } from '@/router'
import { getToken } from '@/utils/cookies'
import { getMenu } from '@/api/user'
import store from '@/store'
import { getType } from '@/utils/cookies'

// 根据接口返回的菜单权限过滤路由表 --- device端
const filterAsyncRoutes = (routes: RouteConfig[], menu: any[]) => {
  const res: RouteConfig[] = []
  // 以查询的菜单列表双循环遍历
  menu.forEach(m => {
    routes.forEach(route => {
      const r = { ...route }
      // 对比父路由
      if (m.path === r.path) {
        // 若操作子路由则递归
        if (m.children && r.children) {
          r.children = filterAsyncRoutes(r.children, m.children)
        }
        // 追加
        res.push(r)
      }
    })
  })

  return res
}

// 根据接口返回的菜单权限过滤路由表 --- mobile端
const h5FilterAsyncRoutes = (routes: RouteConfig[], menu: any[]) => {
  const res: RouteConfig[] = []
  // 以查询的菜单列表双循环遍历
  menu.forEach(m => {
    routes.forEach(route => {
      const r = { ...route }
      // 对比父路由
      if (m.path === r.path.replace('/h5', '')) {
        // 若操作子路由则递归
        if (m.children && r.children) {
          r.children = h5FilterAsyncRoutes(r.children, m.children)
        }
        // 追加
        res.push(r)
      }
    })
  })

  return res
}

export interface IPermissionState {
  routes: RouteConfig[]
  dynamicRoutes: RouteConfig[]
  permission: string[]
  menu: any[]
  manager: string
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = []
  public dynamicRoutes: RouteConfig[] = []
  public permission: string[] = []
  public need_approval_permission: string[] = []
  public approval_task_detail: any = {}
  public menu: any[] = []
  public manager: string = ''

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.routes = constantRoutes.concat(routes)
    this.dynamicRoutes = routes
  }

  @Mutation
  private SET_PERMISSION(permission: string[]) {
    this.permission = permission
  }

  @Mutation
  private SET_NEED_APPROVAL_PERMISSION(need_approval_permission: string[]) {
    this.need_approval_permission = need_approval_permission
  }

  @Mutation
  private SET_MENU(menu: any[]) {
    this.menu = menu
  }

  @Mutation
  private SET_APPROVAL_TASK_DETAIL(approval_task_detail: any) {
    this.approval_task_detail = approval_task_detail
  }
  @Mutation
  private SET_MANAGER(manager: string) {
    this.manager = manager
  }

  @Action
  public async GetMenu() {
    if (!getToken()) {
      throw Error('GetUserInfo: token is undefined!')
    }
    const data = { menu: [], permission: [], need_approval_permission: [], approval_task_detail: {}, manager: '' }
    const res = Object.assign(data, await getMenu())

    const { menu, permission, need_approval_permission, approval_task_detail, manager } = res

    this.SET_MENU(menu)
    this.SET_PERMISSION(permission)
    this.SET_NEED_APPROVAL_PERMISSION(need_approval_permission)
    this.SET_APPROVAL_TASK_DETAIL(approval_task_detail)
    this.SET_MANAGER(manager)
    if (!menu || menu.length <= 0) {
      throw Error('GetUserInfo: menu must be a non-null array!')
    }
  }

  @Action
  public GenerateRoutes(menu: string[]) {
    let accessedRoutes = filterAsyncRoutes(asyncRoutes, menu);   
    // let accessedRoutes = document.body.getBoundingClientRect().width < 770 ? h5FilterAsyncRoutes(h5AsyncRoutes, menu) : filterAsyncRoutes(asyncRoutes, menu);   
    this.SET_ROUTES(accessedRoutes)
  }

  @Action
  public resetAllPermission() {
    this.SET_PERMISSION([])
    this.SET_NEED_APPROVAL_PERMISSION([])
  }
}

export const PermissionModule = getModule(Permission)
